<template>
  <el-dialog
      title="选择图片"
      class="uploaderImgVariant"
      v-if="value"
      :visible.sync="value"
      width="1000px"
      append-to-body
      :before-close="onClose">
    <ul class="select-img" v-if="imgList.length">
      <li
          class="option"
          v-for="(item, index) in imgList"
          :key="item"
          @click="changeVariantSelectImg(item, index)">
        <div
            class="img-mask"
            v-if="variantCheckedImgUidList.some((key) => key === item)">
          <i class="el-icon-upload-success el-true-check">
            {{ getVariantSelectImgIndex(item) }}
          </i>
        </div>
        <img :src="item" alt />
      </li>
    </ul>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="onClose">
        取 消
      </el-button>
      <el-button size="mini" type="primary" @click="saveVariantSelectImg">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Baseurl } from '@/api/api/api'
import { ajaxPost } from '../../../api/api/api'

export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      uploadAction: Baseurl + 'shopeeImage/uploadImage',
      customHeaders: { token: localStorage.getItem('token') },
      variantCheckedImgUidList: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem('role'))
  },
  methods: {
    onClose() {
      this.variantCheckedImgUidList = []
      this.$emit('input', false)
    },
    changeVariantSelectImg(item) {
      this.variantCheckedImgUidList = [item]
    },
    getVariantSelectImgIndex(item) {
      const isHaveIndex = this.variantCheckedImgUidList.findIndex(
          (key) => key === item
      )
      return isHaveIndex + 1
    },
    // 选择图片确定
    saveVariantSelectImg() {
      this.$emit('confirm', this.variantCheckedImgUidList[0])
      this.onClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-img {
  width: 100%;
  height: 320px;
  overflow: auto;

  .option {
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    float: left;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    position: relative;

    .img-mask {
      position: absolute;
      right: -17px;
      top: -7px;
      width: 46px;
      height: 26px;
      background: #13ce66;
      text-align: center;
      transform: rotate(45deg);

      .el-true-check {
        color: #fff;
        font-size: 12px;
        margin-top: 12px;
        transform: rotate(-45deg);
      }
    }

    img {
      width: 146px;
    }
  }
}

.custom-update {
  /deep/ .el-upload--picture-card {
    background: initial;
    border: initial;
    width: initial;
    height: initial;
    line-height: initial;
  }
}
</style>
